/* eslint-disable import/namespace */
import { install, Vue2 } from 'vue-demi';
import * as components from './components';
import * as directives from './directives';
import * as transitions from './transitions';

const libUi = {
  install: Vue => {
    for (const componentName in components) {
      const component = components[componentName];
      if (component?.name || component?.options?.name) {
        Vue.component(component.options?.name || component.name, component);
      }
    }
    for (const transitionName in transitions) {
      const transition = transitions[transitionName];
      if (transition?.name || transition?.options?.name) {
        Vue.component(transition.options?.name || transition.name, transition);
      }
    }
    for (const directiveName in directives) {
      const directive = directives[directiveName];
      Vue.directive(directive.name, directive);
    }
  },
};

export default libUi;
export * from './components';
export * from './directives';
export * from './transitions';

if (typeof window !== 'undefined' && window.Vue) {
  (window as any).Vue.use(libUi);
}

install(Vue2);
